import { Key } from '@/enums/key';
import { KeyDescription } from '@/enums/key_description';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { EOSName } from '@shared/dto/app_info/e_os_name';
import { EShortcutGroup } from '@shared/dto/hint_shortcuts/e_shortcut_group';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { IHintShortcutData } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data';
import { useTranslation } from 'react-i18next';
import { use_slice_app_info } from '../store/use_slices';
import { create_data_row } from './use_hints_shortcuts_data';

export function use_hints_shortcut_paste_image(): IHintShortcutData {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { os_name } = use_slice_app_info(['os_name']);

  let first_key = os_name == EOSName.MACOS ? KeyDescription.Cmd : Key.Control;

  let data_rows = [create_data_row(t(i18n_base_ui.shortcut_hints.generation.generation_settings_image_canvas_paste_image), [first_key, Key.V])];

  return {
    data_rows,
    key: EShortcutType.GENERATION_SETTINGS_IMAGE_CANVAS_PASTE_IMAGE,
    keys_have_same_animation_delay: true,
    group: EShortcutGroup.GENERATION,
  };
}
